export default __webpack_public_path__ + "static/media/boeuf.7dc8583d.jpg";